
import { isEmail } from 'validator';
import { isString } from 'lodash';
import { CLAccount } from './account';

export type CLUserRole = 'OWNER' | 'SIMPLE';

interface CLEmailVerification {
  email: string
  expiresAt: number
  createdAt: number
}

interface CreateCLUserInput {
  username: string
  password: string
  timezone: string
  role: CLUserRole
  firstname: string
  lastname: string
  account: string
}

interface UpdateCLUserInput {
  username: string
  password: string
  timezone: string
  firstname: string
  lastname: string
}

export class CLUser {
  id: string
  username: string
  account: CLAccount
  role: CLUserRole
  firstname: string
  lastname: string
  emailVerified: boolean
  timezone: string
  deleted: boolean
  createdAt: number
  updatedAt: number
  latestEmailVerification?: CLEmailVerification

  password: string

  constructor(data: any = {}) {
    Object.assign(this, data);

    if (this.account) {
      this.account = new CLAccount(this.account);
    }
  }

  get fullname() {
    if(this.firstname && this.lastname) {
      return `${this.firstname} ${this.lastname}`;
    }
    else if(this.firstname) {
      return this.firstname;
    }
    else if(this.lastname) {
      return this.lastname;
    }
    else if(this.username) {
      return this.username;
    }
    else {
      return this.id;
    }
  }

  toCreateCLUserInput(): CreateCLUserInput {
    return {
      username: this.username,
      password: this.password,
      firstname: this.firstname,
      lastname: this.lastname,
      timezone: this.timezone,
      role: this.role,
      account: this.account.id,
    };
  }

  toUpdateCLUserInput(): UpdateCLUserInput {
    return {
      username: this.username,
      password: this.password,
      firstname: this.firstname,
      lastname: this.lastname,
      timezone: this.timezone,
    };
  }

  get valid():boolean {
    // username
    if(!isString(this.username)) {
      return false;
    }

    let trimmedUsername = this.username.trim();

    if(trimmedUsername.length > 50) {
      return false;
    }

    if(!isEmail(trimmedUsername)) {
      return false;
    }

    // password (validated only if set or the user is new)
    if((this.id && this.password) || !this.id) {
      if (!isString(this.password)) {
        return false;
      }

      let trimmedPassword = this.password.trim();

      if (trimmedPassword.length < 8 || trimmedPassword.length > 50) {
        return false;
      }
    }

    // Account
    if (!this.account) {
      return false;
    }

    // Role
    if (!this.role) {
      return false;
    }

    return true;
  }
}
